import script from "./security.vue?vue&type=script&setup=true&lang=js"
export * from "./security.vue?vue&type=script&setup=true&lang=js"

import "./security.vue?vue&type=style&index=0&id=1675c07c&lang=scss&scoped=true"
import "./security.vue?vue&type=style&index=1&id=1675c07c&lang=scss"

import exportComponent from "/data/soft/jenkins/workspace/S09_ehm-acsecurity-pro-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1675c07c"]])

export default __exports__